import { useCallback } from "react";

import { useTableContext } from "./contexts/table-context.js";
import { TableSelection, useSelectionContext } from "./contexts/selection-context.js";

function selectorClass(base, fullySelected) {
    return `${base}${fullySelected ? " fully-selected" : ""}`;
}

export function ColumnSelector({ index }) {
    const { selection, setSelection } = useSelectionContext();
    const { table } = useTableContext();

    const onColumnSelect = useCallback(
        (event) => {
            event.preventDefault();
            if (!selection) {
                setSelection(new TableSelection({ row: 0, cell: index }, { row: table.rows.length - 1, cell: index }));
                return;
            }
            setSelection(selection.selectColumn(index, event.shiftKey, table));
        },
        [index, selection, setSelection, table],
    );

    return (
        <td
            onMouseDown={onColumnSelect}
            className={selectorClass(
                "table-generator-selector-cell column-selector",
                selection?.isColumnSelected(index, table),
            )}
        />
    );
}

export function RowSelector({ index }) {
    const { table } = useTableContext();
    const { selection, setSelection } = useSelectionContext();

    const onSelect = useCallback(
        (event) => {
            event.preventDefault();
            if (!selection) {
                setSelection(
                    new TableSelection({ row: index, cell: 0 }, { row: index, cell: table.columns.length - 1 }),
                );
                return;
            }
            setSelection(selection.selectRow(index, event.shiftKey, table));
        },
        [index, selection, setSelection, table],
    );

    return (
        <td
            onMouseDown={onSelect}
            className={selectorClass(
                "table-generator-selector-cell row-selector",
                selection?.isRowSelected(index, table),
            )}
        />
    );
}
